"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelSubscriptionHandler = cancelSubscriptionHandler;
exports.dispatchCancelSubscriptionFailedEvent = void 0;
var CancelSubscriptionFailed = _interopRequireWildcard(require("@ori-events/cancel-subscription-failed"));
var _types = require("../types");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const dispatchCancelSubscriptionFailedEvent = detail => {
  const event = new CustomEvent(CancelSubscriptionFailed.Name, {
    detail
  });
  window.dispatchEvent(event);
};
exports.dispatchCancelSubscriptionFailedEvent = dispatchCancelSubscriptionFailedEvent;
async function cancelSubscriptionHandler({
  detail: {
    consumerId,
    packageId,
    placement,
    subscriptionId
  }
}) {
  const response = await fetch(`${_types.RequestUrl.CancelSubscription}?consumerId=${consumerId}&subscriptionId=${subscriptionId}&packageId=${packageId}`, (0, _utils.getHttpRequestSettings)({
    placement
  }));
  const data = (0, _utils.convertToCamelCase)(await response.json());
  if (CancelSubscriptionFailed.isCancelSubscriptionErrorResponse(data)) {
    dispatchCancelSubscriptionFailedEvent(data);
    return false;
  }
  return data;
}
